<template lang="pug">
  div
    section.content-header
      h1 お知らせの設定
      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active お知らせの設定

    section.content
      app-messages(:errorMessages="errors", :successMessages="successes")

      form(@submit.prevent="postData")
        mixin btnbar
          .row.bcard-btnbar(class!=attributes.class)
            .col-sm-6
              button.btn.btn-primary(:disabled="isLoading" type="submit") 変更
              |
              |
              router-link(:to="{name: 'admin'}")
                button.btn.btn-default キャンセル
        +btnbar

        .box.box-widget
          .box-body
            .form-group
              label.control-label 「同一人物判定」の作業依頼
              .radio.radio-rich
                label
                  input(type="radio" name="notifyMergeTask" :value="app_flag.ON" v-model="notifyMergeTask")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;通知する

                label
                  input(type="radio" name="notifyMergeTask" :value="app_flag.OFF" v-model="notifyMergeTask")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;通知しない

              .help-block
                p.bcard-comments.text-info
                  | ※「名寄せ候補名刺」の一覧に新しいデータが追加された際に、ユーザーにお知らせを送ることができます。

            hr

            .form-group
              label.control-label 「イベント」のお知らせの保存期間
              .row
                .col-xs-3
                  .form-inline.bcard-saveInformation
                    input.form-control(type="number" v-model="saveInformation" min="1" max="999")
                    label 日
              .help-block
                p.bcard-comments.text-info
                  | ※ 通知日から指定の日数が経過した「イベント」のお知らせを削除します。
                p.bcard-comments.text-danger
                  | ※ 未読のお知らせも削除します。

        +btnbar(class="-bottom")
</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'
import RepositoryFactory from '@/repositories/RepositoryFactory'

// TODO mock用（仮）
const InformationSettingsRepository = RepositoryFactory.get('infosettings')

export default {
  name: 'InfoSettings',
  components: { AppMessages },
  data () {
    return {
      saveInformation: 0, // お知らせ
      notifyMergeTask: '1', // app_flag.ON
      isLoading: true // 読み込み中かどうか
    }
  },
  created () {
    // 設定値を取得する
    const vm = this
    InformationSettingsRepository.get()
      .then(function (response) {
        const data = vm.getApiData(response).data
        vm.saveInformation = data.save_information
        vm.notifyMergeTask = data.notify_merge_task
        vm.isLoading = false
      })
      .catch(function (error) {
        vm.setErrorMessage(error)
      })
  },
  methods: {
    // 設定値を更新する
    postData () {
      const vm = this

      // パラメータ
      const data = {
        save_information: this.saveInformation,
        notify_merge_task: this.notifyMergeTask
      }

      // API実行
      InformationSettingsRepository.put(data)
        .then(function () {
        // 成功時は設定状況に遷移
          vm.$router.push({name: 'admin'})
        }).catch(function (error) {
          // エラー時はメッセージを表示
          scrollTo(0, 0)
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/envsettings/InfoSettings.vue